import { Divider, Tag } from "antd";
import axios from "axios";
import React, {
  Key,
  ReactElement,
  useCallback,
  useEffect,
  useState,
} from "react";
import { authenticateToken } from "../../utils/auth";
import Loader from "../common/Loader";

const GroupDetails = ({
  GroupDetails,
}: {
  GroupDetails: any;
}): ReactElement => {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState<any>("JC_MART");
  // --------------------------------
  const [groupServices, setGroupServices] = useState<any>({
    loading: false,
    list: [],
  });

  const getServicesByGroup = useCallback(
    async (groupId?: string) => {
      setLoading(true);
      const encodedUri = `${process.env.REACT_APP_AUTH_API}`;
      return axios
        .get(
          `${encodedUri}/service-group/services-by-group?groupId=${groupId}&serviceType=${type}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res: any) => {
          setGroupServices({
            loading: false,
            list: res?.data?.serviceGroups,
          });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error("Services: Error", err);
        });
    },
    [type]
  );

  useEffect(() => {
    if (GroupDetails) {
      getServicesByGroup(GroupDetails?.id);
    }
  }, [GroupDetails]);

  return (
    <div className="add-product drawer-toggle-wrapper">
      <div className="drawer-toggle-inner-wrapper">
        <div className="inner-body-wrapper">
          <div className="inner-body">
            <div className="single">
              <div className="info-name">
                <span>Group Name</span>
              </div>
              <div className="info-desc">
                <span>{GroupDetails?.name}</span>
              </div>
            </div>

            <div className="single">
              <div className="info-name">
                <span>Type</span>
              </div>

              <div className="info-desc">
                <span>{`${GroupDetails?.type?.replace("_", " ")}`}</span>
              </div>
            </div>

            {/* <div className="single">
              <div className="info-name">
                <span>Status</span>
              </div>
              <div className="info-desc">
                {groupDetails?.status}
                <span
                  className={`radius-btn ${
                    groupDetails?.status === "true" ? "active" : "inactive"
                  }-btn`}
                >
                  {groupDetails?.status === "true" ? "Active" : "Inactive"}
                </span>
              </div>
            </div> */}
          </div>
        </div>
        <>
          <Divider dashed orientation="left">
            Services
          </Divider>
          {loading ? (
            <Loader />
          ) : (
            groupServices?.list?.map(
              (serviceGroup: any, index: Key | null | undefined) =>
                serviceGroup?.serviceName?.isActive && (
                  <Tag
                    color="#f50"
                    key={index}
                    className="bg-red text-xs font-bold uppercase text-white px-2 py-1 rounded mb-2 mr-2"
                    closable
                  >
                    {serviceGroup?.serviceName?.name} | {serviceGroup?.action}
                  </Tag>
                )
            )
          )}
        </>
      </div>
    </div>
  );
};

export default GroupDetails;
